'use strict';

var $emptyNode = document.createElement('div');


/**
 * Rectangle static render function.
 *
 * @this Object
 *
 * @param {Node} $node DOM element of list item
 */
function rectangleRender ( $node ) {
    /*
    <div class="content-item-record">
        <div class="content-item-record-shadow"></div>
        <div class="content-item-record-container" style="background-color: #ff6650;">
            <div class="content-item-record-icon" style="background-image: url('app/img/720/icons/karaoke.placeholder.png')"></div>
            <div class="content-item-record-info">
                <div class="content-item-record-name">Scorpions</div>
                <div class="content-item-record-description">Return to Forever </div>
            </div>
        </div>
        <div class="content-item-record-fullinfo">
            <div class="content-item-record-title">Return to Forever</div>
            <div class="content-item-record-metadata">Scorpions</div>
        </div>
    </div>
    */
    $node.className = 'content-item-record';

    $node.$shadow = $node.appendChild(document.createElement('div'));
    $node.$shadow.className = 'content-item-record-shadow';

    $node.$container = $node.appendChild(document.createElement('div'));
    $node.$container.className = 'content-item-record-container';
    $node.$container.style.backgroundColor = this.data.colors.background;

    if ( typeof this.data.icon === 'string' ) {
        $node.$icon = $node.$container.appendChild(document.createElement('div'));
        $node.$icon.className = 'content-item-record-card-icon';
        $node.$icon.style.backgroundImage = 'url("' + this.data.icon + '")';
    } else if ( this.data.icon && this.data.icon.normal ) {
        $node.$icon = $node.$container.appendChild(document.createElement('div'));
        $node.$icon.className = 'content-item-record-card-icon';
        $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
    } else {
        $node.$icon = $emptyNode;
    }

    $node.$name = $node.$container.appendChild(document.createElement('div'));
    $node.$name.className = 'content-item-record-name';

    $node.$nameText = $node.$name.appendChild(document.createElement('div'));
    $node.$nameText.className = 'content-item-record-name-text';
    $node.$nameText.innerText = this.data.name;

    $node.$state = document.createElement('div');
    $node.$state.className = 'content-item-record-state';

    $node.$progressBar = document.createElement('div');
    $node.$progressBar.className = 'content-item-record-progress-bar';

    $node.$progressLine = $node.$progressBar.appendChild(document.createElement('div'));
    $node.$progressLine.className = 'content-item-record-progress-line';

    $node.$progressPercent = $node.$progressBar.appendChild(document.createElement('div'));
    $node.$progressPercent.className = 'content-item-record-progress-percent';

    if ( this.data.progress === 0 ) {
        $node.$container.appendChild($node.$state);
        $node.$state.innerText = this.data.state;
    } else if ( this.data.progress === 100 ) {
        $node.$container.appendChild($node.$state);
        $node.$state.innerText = this.data.state;
    } else {
        $node.$container.appendChild($node.$progressBar);
        $node.$progressBar.className = 'content-item-record-progress-bar--active';
        $node.$progressLine.style.width = this.data.progress + '%';
        $node.$progressPercent.innerText = this.data.progress + '%';
    }
}


module.exports = {
    render: rectangleRender,

    focus: function ( $node ) {
        $node.$shadow.className = 'content-item-record-shadow--focus';
        $node.$container.className = 'content-item-record-container--focus';
        $node.$icon.className = 'content-item-record-icon--focus';
        $node.$name.className = 'content-item-record-name--focus';
        $node.$nameText.className = 'content-item-record-name-text--focus';
        $node.$state.className = 'content-item-record-state--focus';

        if ( this.data.progress > 0 && this.data.progress < 100 ) {
            $node.$container.appendChild($node.$progressBar);
            $node.$progressBar.className = 'content-item-record-progress-bar--active-focus';
            $node.$progressLine.className = 'content-item-record-progress-line--focus';
            $node.$progressPercent.className = 'content-item-record-progress-percent--focus';
        }

        if ( this.data.icon && this.data.icon.active ) {
            $node.$icon.style.backgroundImage = 'url("' + this.data.icon.active + '")';
        }
    },

    blur: function ( $node ) {
        $node.$shadow.className = 'content-item-record-shadow';
        $node.$container.className = 'content-item-record-container';
        $node.$icon.className = 'content-item-record-icon';
        $node.$name.className = 'content-item-record-name';
        $node.$nameText.className = 'content-item-record-name-text';
        $node.$state.className = 'content-item-record-state';

        if ( this.data.progress > 0 && this.data.progress < 100 ) {
            $node.$container.appendChild($node.$progressBar);
            $node.$progressBar.className = 'content-item-record-progress-bar--active';
            $node.$progressLine.className = 'content-item-record-progress-line';
            $node.$progressPercent.className = 'content-item-record-progress-percent';
        }

        if ( typeof this.data.icon === 'string' ) {
            $node.$icon.style.backgroundImage = 'url("' + this.data.icon + '")';
        } else if ( this.data.icon && this.data.icon.normal ) {
            $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
        }
    }
};
